export enum EnAuthGuardBehaviour {
  Login,
  Hide,
  InfoMessage,
  Fallback
}
